import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { updateStats } from './util.update-stats.js';

function useUpdateTaskEntryMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return (taskId, value) => mutater(entry => {
    const taskEntry = entry.data.tasks[taskId] ??= makeInitialOpgavekompleksetTaskEntry(data, taskId);
    taskEntry.details = typeof value === "function" ? value(taskEntry.details) : value;
    updateStats(entry, data, taskId);
    taskEntry.state.validated = false;
    taskEntry.state.skipped = false;
    return entry;
  });
}

export { useUpdateTaskEntryMutation };
//# sourceMappingURL=update-task-entry.js.map
